// A local view of the (still experimental) scheduler global. Deliberately NOT a
// `declare global` augmentation: TS 5.9's lib.dom has no `scheduler` yet, while
// tsgo's newer lib.dom ships it with a required `yield` - an augmentation cannot
// satisfy both, but this cast compiles identically under either lib.
const getScheduler = () => (globalThis as { scheduler?: { yield?: () => Promise<void> } }).scheduler

// break long task to smaller tasks, see here: https://web.dev/optimize-long-tasks/#use-asyncawait-to-create-yield-points
export const yieldToMain = () => {
	if (
		process.env.browser &&
		process.env.PACKAGE_NAME !== 'thunderbolt-ds' &&
		process.env.RENDERER_BUILD !== 'react-native'
	) {
		const scheduler = getScheduler()
		if (scheduler?.yield) {
			return scheduler.yield()
		}

		return new Promise((resolve) => setTimeout(resolve, 0))
	}
}

export const taskify = async <T>(task: () => T) => {
	await yieldToMain()
	return task()
}
